import { useMemo } from 'react'
import useDashboardCardSetting from './useDashboardCardSetting'
import { DASHBOARD_FILTER_FIELDS } from '../helpers/dashboardHelpers/dashboardCardFilters'
import { filterByLocation } from '../helpers/locations/locationFilter'

// AI-CONTEXT: See docs/patterns.md#data-analytics-pin-snapshot

/**
 * Locatiefilter-state voor een dashboardkaart, desgewenst bewaard op een
 * `DashboardItems`-document. Met `options.item` begint de keuze bij
 * `item.SelectedLocationId` en wordt elke wijziging daar teruggeschreven;
 * zonder `item` gedraagt hij zich als een gewone `useState`.
 *
 * **Werkt op elke lijst met een `LocationID`**, niet alleen op deelnemers.
 * Locaties zijn één instelling die huishoudens en deelnemers delen — een
 * fixbrigade heeft fixers én huishoudens op dezelfde locatie. Hij heette
 * hiervoor `usePersonaLocationFilter`; die naam liet lezers denken dat er voor
 * huishoudens een tweede hook bij moest.
 * AI-CONTEXT: See docs/features/huishouden-locaties.md
 *
 * @param {Array<object>} items - De lijst om te filteren.
 * @param {object} [options]
 * @param {object} [options.item] - The static-card `DashboardItems` doc (must have `docid`).
 * @returns {{
 *   filteredItems: Array<object>,
 *   selectedLocationId: string,
 *   setSelectedLocationId: (newId: string) => void,
 * }}
 */
const useLocationFilter = (items, options = {}) => {
    const { item } = options
    const [selectedLocationId, setSelectedLocationId] = useDashboardCardSetting(
        item,
        DASHBOARD_FILTER_FIELDS.SelectedLocationId,
        '',
    )

    const filteredItems = useMemo(
        () => filterByLocation(items, selectedLocationId),
        [items, selectedLocationId],
    )

    return { filteredItems, selectedLocationId, setSelectedLocationId }
}

export default useLocationFilter
